
<template>
  <!-- eslint-disable -->
  <svg :style="style" :class="classes" data-components="LogoAutoteile24Svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 156 24"><path fill="#fff" d="M3.9 22.3c-1-.6-1.8-1.5-2.4-2.5-.6-1-.9-2.2-.9-3.4s.3-2.4.9-3.4c.6-1.1 1.4-1.9 2.4-2.6 1-.6 2.1-1 3.3-1 2 0 3.5.6 4.5 1.9V9.7h4.5V23h-4.5v-1.6c-.4.6-1 1.1-1.9 1.4-.8.3-1.7.5-2.6.5-1.2 0-2.3-.3-3.3-1zm7-3.6c.6-.7.9-1.4.9-2.3s-.3-1.7-.9-2.3c-.6-.7-1.4-1-2.2-1-.9 0-1.6.3-2.2 1s-.9 1.4-.9 2.3.3 1.6.9 2.3 1.4 1 2.2 1c.8 0 1.6-.3 2.2-1zm10.3 3c-.8-1.1-1.2-2.5-1.2-4.4V9.8h4.5v7.5c0 1.6.7 2.4 2 2.4.7 0 1.3-.3 1.8-1 .5-.6.7-1.4.7-2.3V9.8h4.5V23H29v-1.6c-.5.6-1 1.1-1.7 1.4-.7.3-1.5.5-2.3.5-1.7 0-3-.5-3.8-1.6zm17.3-8.4h-2.4V9.8h2.4v-5H43v5h2.4v3.5H43v9.8h-4.5v-9.8zm11.7 9.1c-1.2-.6-2.1-1.4-2.7-2.4-.7-1-1-2.2-1-3.6 0-1.3.3-2.5 1-3.6s1.6-1.9 2.7-2.4 2.4-.9 3.8-.9 2.6.3 3.8.9c1.1.6 2.1 1.4 2.7 2.4.7 1 1 2.2 1 3.6s-.3 2.6-1 3.6-1.6 1.8-2.7 2.4c-1.2.6-2.4.8-3.8.8-1.4.1-2.6-.2-3.8-.8zm6.2-3.5c.5-.7.7-1.5.7-2.5s-.2-1.8-.7-2.4-1.3-1-2.3-1c-1.1 0-1.9.3-2.4 1s-.7 1.5-.7 2.4c0 1 .2 1.8.7 2.5.5.7 1.3 1 2.4 1 1.1 0 1.8-.3 2.3-1zm8.8-5.6h-2.4V9.8h2.4v-5h4.5v5h2.4v3.5h-2.4v9.8h-4.5v-9.8zm11.7 9.1c-1.2-.6-2.1-1.4-2.7-2.4-.7-1-1-2.2-1-3.6s.3-2.6 1-3.6 1.6-1.9 2.7-2.4c1.2-.6 2.5-.9 4-.9 1.4 0 2.6.3 3.7.8s2 1.3 2.6 2.3c.7 1 1 2.2 1 3.5v.8H78c0 .8.3 1.5.8 2.2.5.6 1.2 1 2.1 1 .8 0 1.4-.2 1.9-.6.5-.4.7-.9.8-1.4h4.6c-.4 1.7-1.2 3-2.5 3.9-1.3.9-2.8 1.3-4.6 1.3-1.7 0-3-.3-4.2-.9zm7.1-7.6c-.1-.7-.4-1.3-.9-1.8s-1.2-.7-2.1-.7c-.9 0-1.5.2-2 .7-.5.4-.8 1-.9 1.8H84zm7.4-7.7c-.5-.5-.8-1.1-.8-1.9 0-.7.3-1.4.8-1.9s1.1-.8 1.9-.8c.7 0 1.3.3 1.9.8.5.5.8 1.1.8 1.9 0 .7-.3 1.3-.8 1.9-.5.5-1.1.8-1.9.8-.8 0-1.4-.3-1.9-.8zM91 9.8h4.5V23H91V9.8zM99.6.5h4.5V23h-4.5V.5zm10.9 21.9c-1.2-.6-2.1-1.4-2.7-2.4s-1-2.2-1-3.6.3-2.6 1-3.6 1.6-1.9 2.7-2.4c1.2-.6 2.5-.9 4-.9 1.4 0 2.6.3 3.7.8s2 1.3 2.6 2.3c.7 1 1 2.2 1 3.5v.8h-10.3c0 .8.3 1.5.8 2.2.5.6 1.2 1 2.1 1 .8 0 1.4-.2 1.9-.6.5-.4.7-.9.8-1.4h4.6c-.4 1.7-1.2 3-2.5 3.9-1.3.9-2.8 1.3-4.6 1.3-1.6 0-2.9-.3-4.1-.9zm7.1-7.6c-.1-.7-.4-1.3-.9-1.8s-1.2-.7-2.1-.7c-.9 0-1.5.2-2 .7-.5.4-.8 1-.9 1.8h5.9zm13.6-2.1c.1-.1.3-.4.8-.9.4-.5.7-1 1-1.5.2-.5.4-.9.4-1.4 0-.7-.2-1.3-.6-1.7-.4-.4-1-.6-1.7-.6-.8 0-1.4.2-1.8.7s-.7 1.3-.7 2.3h-4.2c0-1.3.3-2.6.8-3.7s1.3-2 2.3-2.6c1-.7 2.2-1 3.6-1 1.3 0 2.5.3 3.5.8 1 .6 1.8 1.3 2.3 2.3.5 1 .8 2.2.8 3.5 0 .9-.1 1.7-.4 2.4-.3.7-.6 1.4-1 2s-1 1.3-1.7 2.2l-.6.7-2.2 2.7h6.2V23h-14.8l8-10.3zm24.3 2.2V19h-1.7v4h-4.5v-4h-10L147 2.6h6.8v12.3h1.7zm-6.1 0v-9l-3.9 9h3.9z"/></svg>
</template>

<script>
import globalMixin from 'Libs/mixins/globalMixin';

export default {
  name: 'LogoAutoteile24Svg',
  mixins: [globalMixin],
  props: {
    width: {
      type: [String, Number, Boolean],
      default: false
    },
    height: {
      type: [String, Number, Boolean],
      default: false
    },
    original: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    style() {
      const style = {};

      if (this.width) {
        style.width = this.width + 'px';
      }

      if (this.height) {
        style.height = this.height + 'px';
      }

      return style;
    }
  }
};
</script>
